<script>
  import { onMount } from 'svelte';
  import fetchAdminAPI from '../adminApi.js';

  export let authData;

  let prizes = [];
  let loading = true;
  let error = null;

  let currentPage = 1;
  let pageSize = 10;
  let totalPrizes = 0;

  let filterStatus = ""; // "pending", "claimed", "shipped", "rejected"
  let filterUserId = "";
  const prizeStatuses = ["pending", "claimed", "shipped", "rejected"];


  let showEditModal = false;
  let currentPrize = null;
  let editPrizeData = { status: '', admin_notes: null };

  onMount(() => {
    loadPrizes();
  });

  async function loadPrizes() {
    loading = true;
    error = null;
    const params = {
      page: currentPage,
      pageSize: pageSize,
      status: filterStatus || undefined,
      userId: filterUserId || undefined,
    };
    const result = await fetchAdminAPI('/prizes', 'GET', params, authData);
    if (result.success) {
        prizes = result.data.data || [];      // <--- ИЗМЕНЕНИЕ
        totalPrizes = result.data.total || 0; // <--- ИЗМЕНЕНИЕ
    } else {
      error = result.message;
      prizes = [];
      totalPrizes = 0;
    }
    loading = false;
  }

  function handleFilter() {
    currentPage = 1;
    loadPrizes();
  }

  function openEditModal(prize) {
    currentPrize = prize;
    editPrizeData = {
      status: prize.Status,
      admin_notes: prize.AdminNotes,
    };
    showEditModal = true;
  }

  async function handleUpdatePrizeStatus() {
    if (!currentPrize) return;
    const payload = {
      status: editPrizeData.status,
      admin_notes: editPrizeData.admin_notes === "" ? null : editPrizeData.admin_notes,
    };

    if (!prizeStatuses.includes(payload.status)) {
        alert("Неверный статус приза.");
        return;
    }

    const result = await fetchAdminAPI(`/prizes/${currentPrize.ID}`, 'PATCH', payload, authData);
    if (result.success) {
      showEditModal = false;
      currentPrize = null;
      loadPrizes();
    } else {
      alert(`Ошибка обновления статуса приза: ${result.message}`);
    }
  }

  function changePage(newPage) {
    currentPage = newPage;
    loadPrizes();
  }

  $: totalPages = Math.ceil(totalPrizes / pageSize);
</script>
<div class="prizes-admin-section">
  <div class="admin-section-header">
    <h2>Управление призами пользователей</h2>
  </div>

  <div class="filters-bar">
    <input type="text" bind:value={filterUserId} placeholder="TG ID пользователя" on:input={handleFilter} on:keypress={(e) => e.key === 'Enter' && handleFilter()}>
    <select bind:value={filterStatus} on:change={handleFilter} aria-label="Фильтр по статусу">
      <option value="">Все статусы</option>
      {#each prizeStatuses as status (status)}
        <option value={status}>{status}</option>
      {/each}
    </select>
    <button class="admin-primary" on:click={handleFilter}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel-fill" viewBox="0 0 16 16" style="margin-right: 6px; vertical-align: text-bottom;">
            <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
        </svg>
        Фильтровать
    </button>
  </div>

  <div class="admin-card">
    {#if loading}
      <div style="text-align:center; padding: 30px 0;">
        <div class="spinner-large" style="margin: 0 auto 10px auto;"></div>
        <p>Загрузка призов...</p>
      </div>
    {:else if error}
      <p style="color: #d9534f; text-align:center; padding: 20px;">Ошибка: {error}</p>
    {:else if prizes.length === 0}
        <p style="text-align:center; padding: 20px; color: #555;">{filterUserId || filterStatus ? 'Призы по вашему запросу не найдены.' : 'Выигранных призов пока нет.'}</p>
    {:else}
      <div class="table-responsive-wrapper">
        <table class="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>TG ID</th>
              <th>Username</th>
              <th>Prize ID (сектор)</th>
              <th>Статус</th>
              <th>Выигран</th>
              <th>Запрошен</th>
              <th>Заметки</th>
              <th style="text-align: right;">Действия</th>
            </tr>
          </thead>
          <tbody>
            {#each prizes as prize (prize.ID)}
              <tr>
                <td>{prize.ID}</td>
                <td>{prize.UserID}</td>
                <td>{prize.Username || '–'}</td>
                <td>{prize.PrizeID}</td>
                <td>
                    <span class="status-tag status-{prize.Status.toLowerCase()}">
                        {prize.Status}
                    </span>
                </td>
                <td>{new Date(prize.WonAt).toLocaleString()}</td>
                <td>{prize.ClaimedAt ? new Date(prize.ClaimedAt).toLocaleString() : '–'}</td>
                <td title={prize.AdminNotes || ''} style="max-width: 150px; overflow: auto; text-overflow: ellipsis; white-space: nowrap;">{prize.AdminNotes || '–'}</td>
                <td class="admin-actions" style="text-align: right;">
                  <button class="admin-action-button admin-edit" on:click={() => openEditModal(prize)}>Статус</button>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
      {#if totalPrizes > 0}
      <div class="pagination">
        <span class="page-info">Показано {prizes.length} из {totalPrizes} призов</span>
        <div class="page-controls">
          <button class="admin-action-button" on:click={() => changePage(currentPage - 1)} disabled={currentPage <= 1}>Назад</button>
          <span>Стр. {currentPage} из {totalPages}</span>
          <button class="admin-action-button" on:click={() => changePage(currentPage + 1)} disabled={currentPage >= totalPages}>Вперед</button>
          <select bind:value={pageSize} on:change={() => { currentPage = 1; loadPrizes(); }} aria-label="Записей на странице">
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>
      {/if}
    {/if}
  </div>
</div>

<!-- Edit Prize Status Modal -->
{#if showEditModal && currentPrize}
  <div class="modal" on:click|self={() => showEditModal = false} role="dialog" aria-modal="true">
    <div class="modal-content">
      <h3>Изменить статус приза ID: {currentPrize.ID}</h3>
      <p style="font-size: 0.9em; margin-bottom: 15px;">Пользователь: <strong>{currentPrize.Username || currentPrize.UserID}</strong>, Приз: <strong>{currentPrize.PrizeID}</strong></p>
      <form on:submit|preventDefault={handleUpdatePrizeStatus} class="admin-form">
        <label for="edit-prize-status">Статус:</label>
        <select id="edit-prize-status" bind:value={editPrizeData.status}>
          {#each prizeStatuses as status (status)}
            <option value={status}>{status}</option>
          {/each}
        </select>
        
        <label for="edit-admin-notes">Заметки администратора:</label>
        <textarea id="edit-admin-notes" bind:value={editPrizeData.admin_notes} rows="3"></textarea>
        
        <div class="form-actions">
          <button type="button" on:click={() => {showEditModal = false; currentPrize = null;}} class="admin-secondary">Отмена</button>
          <button type="submit" class="admin-primary">Сохранить</button>
        </div>
      </form>
    </div>
  </div>
{/if}

<style>
  .table-responsive-wrapper { overflow-x: auto; }
  .status-tag {
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 0.8em;
    font-weight: 500;
    text-transform: capitalize; /* Оставляем capitalize */
    display: inline-block;
    border: 1px solid transparent;
  }
  /* Цвета для статусов призов (примерные, можно настроить) */
  .status-pending { background-color: rgba(251, 191, 36, 0.15); color: #FCD34D; border-color: rgba(251,191,36,0.3); } /* Amber */
  .status-claimed { background-color: rgba(96, 165, 250, 0.15); color: #93C5FD; border-color: rgba(96,165,250,0.3); } /* Blue */
  .status-shipped { background-color: rgba(52, 211, 153, 0.15); color: #6EE7B7; border-color: rgba(52,211,153,0.3); } /* Emerald */
  .status-rejected { background-color: rgba(248, 113, 113, 0.15); color: #FCA5A5; border-color: rgba(248,113,113,0.3); } /* Red */
</style>